export default __webpack_public_path__ + "static/media/caragols.584140a4.jpg";